import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { SocialNetworkProfileServices } from "@/services/bedrock/SocialNetworkProfileServices";
import { getErrorMessage } from "@/utils/errorHandler";
import { useClearSocialProfileReviewRepliesCache } from "@/utils/useSocialProfileReviewReplies";
import { useClearSocialProfileReviewsCache } from "@/utils/useSocialProfileReviews";

export const useCreateSocialProfileReviewReply = (
  userId: string | number,
  socialIdentityId: string | number,
  reviewId: string | number,
  options?: { onSuccess?: () => void }
) => {
  const clearSocialProfileReviewsCache = useClearSocialProfileReviewsCache(userId, socialIdentityId);
  const clearSocialProfileReviewRepliesCache = useClearSocialProfileReviewRepliesCache(
    userId,
    socialIdentityId,
    reviewId
  );

  return useMutation({
    mutationFn: (message: string) =>
      SocialNetworkProfileServices.createReviewReply(userId, socialIdentityId, reviewId, message),
    onSuccess: () => {
      toast.success("Reply posted.");
      clearSocialProfileReviewsCache();
      clearSocialProfileReviewRepliesCache();
      options?.onSuccess?.();
    },
    onError: error => {
      toast.error(getErrorMessage(error) || "Failed to post reply.");
    },
  });
};
